module.exports = __webpack_public_path__ + "static/img/azb2.6148f7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/azb2.jpg
// module id = qDDN
// module chunks = 1